function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";
import { resetAndStopAnimation, moveNodeByWorldPosition } from "@ps/bridge/qc/node";
import ScreenSplitProp from "@ps/views/workbench/right-pane/screen-split-prop.vue";
import { SpecNodeGhostName } from "@ps/store/workbench/stage/config/layer-config";
import { getUnSplitPropValue, setUnSplitPropValue } from "@ps/bridge/qc/scripts/editor";
import { updatePositionTween } from "@ps/workbench/animation";
import { getNodeWorldPosition, convertCoordinateByWorldScale } from "@ps/bridge/qc/base";
var AddTweenPosition = /*#__PURE__*/ function(Vue1) {
    "use strict";
    _inherits(AddTweenPosition, Vue1);
    var _super = _createSuper(AddTweenPosition);
    function AddTweenPosition() {
        _classCallCheck(this, AddTweenPosition);
        var _this;
        _this = _super.apply(this, arguments);
        _this.showing = false;
        _this.splitProp = false;
        _this.positionFormValue = {
            x: 0,
            y: 0
        };
        return _this;
    }
    var _proto = AddTweenPosition.prototype;
    _proto.handleFormValueChange = function handleFormValueChange() {
        this.setFormValue();
        this.getSplitProp();
    };
    _proto.mounted = function mounted() {
        this.setFormValue();
        this.getSplitProp();
    };
    _proto.setFormValue = function setFormValue() {
        var targetNode = this.currentSceneNode.getChild(SpecNodeGhostName);
        if (targetNode) {
            // const tempWidth = targetNode.width * targetNode.scaleX * 0.5
            // const tempHeight = targetNode.height * targetNode.scaleY * 0.5
            this.positionFormValue.x = Number(getNodeWorldPosition(targetNode).x.toFixed(1));
            this.positionFormValue.y = Number(getNodeWorldPosition(targetNode).y.toFixed(1));
        }
    };
    _proto.getSplitProp = function getSplitProp() {
        this.splitProp = getUnSplitPropValue(this.activeNode, this.spliptName);
    };
    _proto.toggle = function toggle() {
        if (this.showing) {
            this.hide();
        } else {
            // 切换到编辑状态暂停播放
            resetAndStopAnimation(this.activeNode);
            this.show();
        }
    };
    _proto.handleChangeX = function handleChangeX(x) {
        var targetNode = this.currentSceneNode.getChild(SpecNodeGhostName);
        var factPosition = convertCoordinateByWorldScale({
            x: x,
            y: this.positionFormValue.y
        });
        moveNodeByWorldPosition({
            node: targetNode,
            x: factPosition.x,
            y: factPosition.y
        });
        this.updateCurrentAnimation({
            x: targetNode.x,
            y: targetNode.y
        });
    };
    _proto.handleChangeY = function handleChangeY(y) {
        var targetNode = this.currentSceneNode.getChild(SpecNodeGhostName);
        var factPosition = convertCoordinateByWorldScale({
            x: this.positionFormValue.x,
            y: y
        });
        moveNodeByWorldPosition({
            node: targetNode,
            x: factPosition.x,
            y: factPosition.y
        });
        this.updateCurrentAnimation({
            x: targetNode.x,
            y: targetNode.y
        });
    };
    _proto.show = function show() {
        this.showing = true;
        this.updateTweenPositionAreaActived(true);
        this.disableLinkageNode(this.activeNode);
    };
    _proto.hide = function hide() {
        // 更新激活节点前，生成虚拟节点
        this.updateTweenPositionAreaActived(false);
        this.showing = false;
        this.enableLinkageNode(this.activeNode);
    };
    _proto.changeSplitProp = function changeSplitProp(value) {
        this.splitProp = value;
        setUnSplitPropValue(this.activeNode, this.spliptName, value);
        updatePositionTween(this.activeNode);
    };
    _proto.beforeDestroy = function beforeDestroy() {
        if (this.showing && this.tweenPositionAreaActived && this.activeNode) {
            this.enableLinkageNode(this.activeNode);
        }
        if (this.tweenPositionAreaActived) {
            this.updateTweenPositionAreaActived(false);
        }
        this.showing = false;
    };
    _createClass(AddTweenPosition, [
        {
            key: "text",
            get: function get() {
                return this.showing ? this.$t("workbench.animation.tweenPosition.hide") : this.$t("workbench.animation.tweenPosition.show");
            }
        },
        {
            key: "uuid",
            get: function get() {
                return this.formValue.uuid;
            }
        },
        {
            key: "spliptName",
            get: function get() {
                return "tweenPosition-".concat(this.formValue.uuid);
            }
        }
    ]);
    return AddTweenPosition;
}(Vue);
__decorate([
    Prop({
        required: true
    })
], AddTweenPosition.prototype, "config", void 0);
__decorate([
    Prop({
        required: true
    })
], AddTweenPosition.prototype, "formValue", void 0);
__decorate([
    State(function(state) {
        return state.workspace.sceneManager.currentSceneNode;
    })
], AddTweenPosition.prototype, "currentSceneNode", void 0);
__decorate([
    State(function(state) {
        return state.workspace.game.activeNode;
    })
], AddTweenPosition.prototype, "activeNode", void 0);
__decorate([
    State(function(state) {
        return state.workspace.game.device.scale;
    })
], AddTweenPosition.prototype, "sceneScale", void 0);
__decorate([
    State(function(state) {
        return state.workspace.animation.tweenPositionAreaActived;
    })
], AddTweenPosition.prototype, "tweenPositionAreaActived", void 0);
__decorate([
    Mutation("workspace/animation/updateTweenPositionAreaActived")
], AddTweenPosition.prototype, "updateTweenPositionAreaActived", void 0);
__decorate([
    Action("workspace/game/updateActiveNode")
], AddTweenPosition.prototype, "updateActiveNode", void 0);
__decorate([
    Action("workspace/stage/disableLinkageNode")
], AddTweenPosition.prototype, "disableLinkageNode", void 0);
__decorate([
    Action("workspace/animation/updateCurrentAnimation")
], AddTweenPosition.prototype, "updateCurrentAnimation", void 0);
__decorate([
    Action("workspace/stage/enableLinkageNode")
], AddTweenPosition.prototype, "enableLinkageNode", void 0);
__decorate([
    Action("workspace/game/setStyle")
], AddTweenPosition.prototype, "setStyle", void 0);
__decorate([
    Watch("formValue")
], AddTweenPosition.prototype, "handleFormValueChange", null);
AddTweenPosition = __decorate([
    Component({
        components: {
            ScreenSplitProp: ScreenSplitProp
        }
    })
], AddTweenPosition);
export { AddTweenPosition as default };
